'use strict';
module.exports = [
    function() {

        return {
            controller: ['$element', '$scope', yCheckboxCtrl],
            controllerAs: 'ctrl',
            template: '{{ model }}',
            scope: {
                yModel: '=yCheckbox'
            },
            restrict: 'A',
            link: function($scope, $element) {
            },
        };
    }];

class yCheckboxCtrl {
    constructor($element, $scope) {
        this.$element = $element;
        this.$scope = $scope;

        this.yObserveHandler = this.yObserver.bind(this);
        $scope.yModel.observe(this.yObserveHandler);
        this.htmlObserveHandler = this.htmlObserver.bind(this);
        $element[0].addEventListener('click', this.htmlObserveHandler);
        $scope.$on('$destroy', this.destroy.bind(this));

        this.setChecked($scope.yModel.toString());
    }

    yObserver(event) {
        if(event.type == 'insert') {
            this.setChecked(event.object.toString());
        }
    }

    htmlObserver(event) {
        let length = this.$scope.yModel.toString().length;
        this.$scope.yModel.delete(0, length);

        let val = event.target.checked;
        this.$scope.yModel.insert(0, val.toString());
    }

    toBool(val) {
        return val === 'true' || val === '1';
    }

    setChecked(val) {
        this.$element[0].checked = this.toBool(val);
    }


    destroy() {
        this.$scope.yModel.unobserve(this.yObserveHandler);
        this.$element[0].removeEventListener('click', this.htmlObserveHandler);
    }
}
